import { configureStore } from "@reduxjs/toolkit";

import authReducer, * as auth from "./slices/auth";
import integrationsReducer from "./slices/integrations";
import workspaceReducer from "./slices/workspace";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    integrations: integrationsReducer,
    workspace: workspaceReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const initStore = () => {
  store.dispatch(auth.loadUser());
};
